






















import { Component, Prop, Vue } from 'vue-property-decorator';

import * as def from '@/definitions'
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { PolygonLayer } from '@/model/document2/page/surface/design/layer/polygonLayer';
import { Vector2 } from '@/utilityModels/vector2';
import { UuidHelper } from '@/helper/uuidHelper';
import { UserAgentHelper } from '@/helper/userAgentHelper';
@Component({
    components: {
    },
})
export default class PolygonController extends Vue 
{
    private get isMobile() { return UserAgentHelper.isMobile(); }

    // 円の半径
    CIRCLE_RADIUS : number = 5;

    @Prop() private layer! : Layer | null;
    @Prop() private scale! : number;
    @Prop() private cursorWidth! : number;
    @Prop() private cursorHeight! : number;
    @Prop() private offsetX! : number;
    @Prop() private offsetY! : number;

    private get lines()
    {
        if(this.layer == null || !(this.layer instanceof PolygonLayer)) { return []; }
        var lines = new Array();
        for(var i = 0; i < this.layer.getControlPointsNumber(); ++i)
        {
            var point = this.layer.getControlPoint(i);
            var nextIndex = i + 1 < this.layer.getControlPointsNumber() ? i + 1 : 0;
            var next = this.layer.getControlPoint(nextIndex)
            var rotatedPoint = point.rotateDegrees(this.layer.rotate, this.layer.centerX, this.layer.centerY);
            var rotatedNext = next.rotateDegrees(this.layer.rotate, this.layer.centerX, this.layer.centerY);
            lines.push({start: rotatedPoint, end: rotatedNext, startIndex: i, endIndex: nextIndex, key: UuidHelper.getUuid() });
        }
        return lines;
    }

    private get pointArray()
    {
        if(this.layer == null || !(this.layer instanceof PolygonLayer)) { return []; }
        var pointArray = new Array();
        for(var i = 0; i < this.layer.getControlPointsNumber(); ++i)
        {
            var point = this.layer.getControlPoint(i);
            // 回転する
            var rotated = point.rotateDegrees(this.layer.rotate, this.layer.centerX, this.layer.centerY);
            pointArray.push({point : rotated, index: i, key: UuidHelper.getUuid() });
        }
        return pointArray;
    }
    private getX(point : Vector2)
    {
        return point.x * this.scale + this.offsetX;
    }

    private getY(point : Vector2)
    {
        return point.y * this.scale + this.offsetY;
    }

    private get strokeWidth()
    {
        if(this.layer == null || !(this.layer instanceof PolygonLayer)) { return 0; }
        return this.layer.strokeWidth * this.scale;
    }

    private get r()
    {
        return this.cursorWidth / 2;
    }

    private selectPoint(index)
    {
        if(this.layer == null || !(this.layer instanceof PolygonLayer)) { return; }
        this.$emit("selectPoint", index);
    }

    private onMouseOverLine(startIndex, endIndex)
    {
        if(this.layer == null || !(this.layer instanceof PolygonLayer)) { return; }

        this.layer.isTouchedOnLine = true;
        this.layer.lastTouchedLineStartIndex = startIndex;
    }

    private onMouseOutLine()
    {
        if(this.layer == null || !(this.layer instanceof PolygonLayer)) { return; }

        this.layer.isTouchedOnLine = false;
    }

}
